import { ProfileRouteBase } from 'mewe/routes/mixins/profile-route-base';

export default ProfileRouteBase.extend({
  theme: 'group',
});
